// src/store/partners/reducer.ts
import {
  GET_PARTNERS_LOADING,
  GET_PARTNERS_SUCCESS,
  GET_PARTNERS_FAILD,
} from "../types";

export interface PartnersState {
  partners: null;
  loading: boolean;
  error: any;
}

const initialState: PartnersState = {
  partners: null,
  loading: false,
  error: null,
};

export const outLetsByPartnerReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
): PartnersState => {
  switch (action.type) {
    case GET_PARTNERS_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };

    case GET_PARTNERS_SUCCESS:
      // action is GetPartnersSuccessAction
      return {
        ...state,
        loading: false,
        error: null,
        partners: action.payload,
      };

    case GET_PARTNERS_FAILD:
      // action is GetPartnersFailedAction
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};
